import { render, staticRenderFns } from "./PostAdd.vue?vue&type=template&id=6931df66&scoped=true"
import script from "./PostAdd.vue?vue&type=script&lang=js"
export * from "./PostAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6931df66",
  null
  
)

export default component.exports